import { render, staticRenderFns } from "./userTemplatesTableInEntityProfiles.vue?vue&type=template&id=6bf190fe&scoped=true"
import script from "./userTemplatesTableInEntityProfiles.vue?vue&type=script&lang=js"
export * from "./userTemplatesTableInEntityProfiles.vue?vue&type=script&lang=js"
import style0 from "./userTemplatesTableInEntityProfiles.vue?vue&type=style&index=0&id=6bf190fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf190fe",
  null
  
)

export default component.exports